(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('finanziamento', {
            parent: 'entity',
            url: '/finanziamento?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.finanziamento.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/finanziamento/finanziamentos.html',
                    controller: 'FinanziamentoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('finanziamento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('finanziamento-detail', {
            parent: 'entity',
            url: '/finanziamento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.finanziamento.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/finanziamento/finanziamento-detail.html',
                    controller: 'FinanziamentoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('finanziamento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Finanziamento', function($stateParams, Finanziamento) {
                    return Finanziamento.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'finanziamento',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('finanziamento-detail.edit', {
            parent: 'finanziamento-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/finanziamento/finanziamento-dialog.html',
                    controller: 'FinanziamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Finanziamento', function(Finanziamento) {
                            return Finanziamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('finanziamento.new', {
            parent: 'finanziamento',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/finanziamento/finanziamento-dialog.html',
                    controller: 'FinanziamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                codice: null,
                                titolo: null,
                                soggettoFinanziatore: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('finanziamento', null, { reload: 'finanziamento' });
                }, function() {
                    $state.go('finanziamento');
                });
            }]
        })
        .state('finanziamento.edit', {
            parent: 'finanziamento',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/finanziamento/finanziamento-dialog.html',
                    controller: 'FinanziamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Finanziamento', function(Finanziamento) {
                            return Finanziamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('finanziamento', null, { reload: 'finanziamento' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('finanziamento.delete', {
            parent: 'finanziamento',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/finanziamento/finanziamento-delete-dialog.html',
                    controller: 'FinanziamentoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Finanziamento', function(Finanziamento) {
                            return Finanziamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('finanziamento', null, { reload: 'finanziamento' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
